
import { useState } from 'react';

export function BlogCategoriesSection() {
  const [activeCategory, setActiveCategory] = useState('all');

  const categories = [
    { id: 'all', name: 'All Posts', count: 24 },
    { id: 'threats', name: 'Latest Threats', count: 8 },
    { id: 'tips', name: 'Security Tips', count: 6 },
    { id: 'case-studies', name: 'Case Studies', count: 4 },
    { id: 'compliance', name: 'Compliance', count: 3 },
    { id: 'news', name: 'Industry News', count: 3 }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-gray-900 to-black border-b border-gray-700">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-wrap gap-4 justify-center">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setActiveCategory(category.id)}
                className={`px-6 py-3 rounded-full font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  activeCategory === category.id
                    ? 'bg-blue-600 text-white'
                    : 'bg-gray-800/50 text-gray-400 hover:bg-gray-700/50 border border-gray-700'
                }`}
              >
                {category.name} ({category.count})
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
